// extracted by mini-css-extract-plugin
export default {"container":"CC-z","dimension":"DC-z","dimensionLabels":"EC-z"};